<template>
    <Form ref="form" :model="groupList" :label-width="parseInt(attrs.labelWidth)" v-if="isDisplay">
        <Row v-for="(item, index) in groupList.items" :key="index">
            <Col span="6" v-for="(child, k) in attrs.children" :key="k">
                <FormItem
                    :label="attrs.labelWidth > 0 ? child.title : ''"
                    :prop="'items.' + index + '.' + child.field">
                    <!-- :rules="{required: true, message: '请输入', trigger: 'blur'}" -->
                    <ly-hoc :attrs="child" v-model="item[child.field]"></ly-hoc>
                </FormItem>
            </Col> 
            <Col span="4" offset="1" v-if="attrs.mode == 'edit'">
                <Button @click="handleRemove(index)" type="warning" icon="md-close">移除</Button>
            </Col>
        </Row>
        <Row v-if="attrs.mode == 'edit'">
            <Col span="12">
                <FormItem>      
                    <Button type="dashed" long @click="handleAdd" icon="md-add">{{attrs.addText}}</Button>
                </FormItem>
            </Col>
        </Row>
    </Form>
</template>
<script>
    /**
     * 组合组件
     */
    import CompDisplayMixin from '@/utils/compDisplay.mixin'
    export default {
        name: 'LyCombination',
        mixins: [CompDisplayMixin],
        props: {
            value: {
                type: [Object, Array, String],
                default: ''
            },
            attrs: {
                type: Object,
                default: _ => new Object()
            }
        },
        watch: {
            value: {
                handler () {
                    this.bindValue()
                },
                immediate: true
            }
        },
        data () {
            return {
                groupFields: {}, // 对应的字段
                groupList: {
                    items: [
                    ]
                }
            }
        },
        created () {
            this.initField()
        },
        methods: {
            /**
             * 初始化绑定value
             */
            bindValue () {
                // 数组类型
                if (this.value instanceof Array) {
                    if (this.value.length > 0 && this.value != this.groupList.items) {
                        this.groupList.items = this.value
                    }
                }
            },
            /**
             * 初始化对应的字段
             */
            initField () {
                this.attrs.children.forEach((el) => {
                    this.groupFields[el.field] = el.default || ''
                })
                // 初始化添加一个默认项目
                if (this.groupList.items.length < 1 && this.attrs.isDefault) {
                    this.handleAdd()
                }
            },
            /**
             * 添加一项
             */
            handleAdd () {
                this.groupList.items.push(Object.assign({}, this.groupFields))
                this.$emit('input', this.groupList.items)
            },
            /**
             * 删除一项
             */
            handleRemove (i) {
                this.groupList.items.splice(i, 1)
            }
        }
    }
</script>



// WEBPACK FOOTER //
// ../projectCore/src/components/combination/src/index.vue